<template>

      <div class="rm" :ref="'rm_'+index">
        <div @click="selectRegistrationMethod(index)" class="rm-header row">
          <div class="row">
            <div class="col col-15 text-center"><input @input="selectRegistrationMethod(index)" class="input-radio" :id="'rm_'+index" name="rm" type="radio" :value="index"></div>
            <div class="col col-85">
              <label class="text-left" :for="'rm_'+index">
                <p class="mb-0 mt-0 lh-1-6"><strong>{{registration_method.name === 'Email' ? `Visitor WiFi Access` : registration_method.name}}</strong></p>
                <p class="mb-0 mt-0 text-16 lh-1-6" v-if="this.generateDescription(registration_method)">{{this.generateDescription(registration_method)}}</p>
              </label>
            </div>
          </div>
        </div>
        <div class="rm-form p-30" v-if="selected==index">
          <div v-if="registration_method.registration_method_id==2">
            <div class="row mb-15">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name" />
            </div>
            <div class="row">
              <input v-model="form.room_number" class="input-text rounded" type="text" placeholder="Room Number" />
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==3">
            <div class="row mb-15 p-rel">
              <input v-model="form.first_name" class="input-text rounded" type="text" placeholder="First Name" />
            </div>
            <div class="row mb-15 p-rel">
              <input v-model="form.last_name" class="input-text rounded" type="text" placeholder="Last Name" />
            </div>
            <div class="row mb-15 p-rel">
              <input v-model="form.email_address" class="input-text rounded" type="text" placeholder="Email" />
            </div>
            <div class="row mb-15 p-rel">
              <div class="col col-15">State:</div>
              <select class="col col-85" v-model="form.state_selected">
                <option v-for="state in state_options" :value="state.value" :key="state.value">
                  {{ state.text }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="registration_method.registration_method_id==4" class="row p-rel">
            <input v-model="form.access_code" class="input-text rounded" type="text" placeholder="Access Code" />
          </div>
          <div class="pt-20 mb-15">
            <button @click="emitRegistrationMethodData()" class="btn rounded" type="button" :style="'background: ' + color_background_button + '; color: ' + color_text_button">Continue</button>
          </div>
          <p class="text-center text-14 mb-0">By clicking continue you agree to the
            <span @click="selectTermsOfService(index)" class="text-link">Terms and Conditions</span>
          </p>
          <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->



</template>
<script>
import Axios from "axios";
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      // access_code: null,
      // access_code_valid: true,
      // access_code_error_text: 'Required',
      clicked: false,
      form: {
        access_code: '',
        room_number: '',
        first_name: '',
        last_name: '',
        email_address: '',
        consent: true,
        state_selected: null
      },
      state_options: [
        { value:"AL", text: "Alabama"},
        { value:"AK", text: "Alaska"},
        { value:"AZ", text: "Arizona"},
        { value:"AR", text: "Arkansas"},
        { value:"CA", text: "California"},
        { value:"CO", text: "Colorado"},
        { value:"CT", text: "Connecticut"},
        { value:"DE", text: "Delaware"},
        { value:"DC", text: "District Of Columbia"},
        { value:"FL", text: "Florida"},
        { value:"GA", text: "Georgia"},
        { value:"HI", text: "Hawaii"},
        { value:"ID", text: "Idaho"},
        { value:"IL", text: "Illinois"},
        { value:"IN", text: "Indiana"},
        { value:"IA", text: "Iowa"},
        { value:"KS", text: "Kansas"},
        { value:"KY", text: "Kentucky"},
        { value:"LA", text: "Louisiana"},
        { value:"ME", text: "Maine"},
        { value:"MD", text: "Maryland"},
        { value:"MA", text: "Massachusetts"},
        { value:"MI", text: "Michigan"},
        { value:"MN", text: "Minnesota"},
        { value:"MS", text: "Mississippi"},
        { value:"MO", text: "Missouri"},
        { value:"MT", text: "Montana"},
        { value:"NE", text: "Nebraska"},
        { value:"NV", text: "Nevada"},
        { value:"NH", text: "New Hampshire"},
        { value:"NJ", text: "New Jersey"},
        { value:"NM", text: "New Mexico"},
        { value:"NY", text: "New York"},
        { value:"NC", text: "North Carolina"},
        { value:"ND", text: "North Dakota"},
        { value:"OH", text: "Ohio"},
        { value:"OK", text: "Oklahoma"},
        { value:"OR", text: "Oregon"},
        { value:"PA", text: "Pennsylvania"},
        { value:"RI", text: "Rhode Island"},
        { value:"SC", text: "South Carolina"},
        { value:"SD", text: "South Dakota"},
        { value:"TN", text: "Tennessee"},
        { value:"TX", text: "Texas"},
        { value:"UT", text: "Utah"},
        { value:"VT", text: "Vermont"},
        { value:"VA", text: "Virginia"},
        { value:"WA", text: "Washington"},
        { value:"WV", text: "West Virginia"},
        { value:"WI", text: "Wisconsin"},
        { value:"WY", text: "Wyoming"}
      ],
      revinate: {
        list_token: "d38ef5ae-ec0d-49b0-b644-c456a20d0da6",
        url: "https://contact-api.inguest.com/api/add-contacts-to-lists",
      },
    }
  },
  computed: {
    show_continue:function(){
      const email_method_2_ready = this.registration_method.registration_method_id === 2 && this.form.last_name && this.form.room_number;
      const email_method_3_ready = this.registration_method.registration_method_id === 3 && this.form.consent && this.form.first_name &&  this.form.last_name && this.form.email_address;
      const email_method_4_ready = this.registration_method.registration_method_id === 4 && this.form.access_code;
      return email_method_2_ready || email_method_3_ready || email_method_4_ready;
    },
  },
  watch: {
    'selected':function(){
      this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
    }
  },
  mounted(){
    this.$el.querySelector( '#rm_' + this.index ).checked = (this.selected == this.index);
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;
      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      description += ' for ';

      if(rm.duration>=1440){
        if(rm.duration % 1440 > 0){
          description += ' more than ';
        }
        var whole_days = Math.floor(rm.duration / 1440);
        description += whole_days + ' day'
        if(whole_days > 1){
          description += 's';
        }
      } else if(rm.duration>=60){
        if(rm.duration % 60 > 0){
          description += ' more than ';
        }
        var whole_hours = Math.floor(rm.duration / 60);
        description += whole_hours + ' hour'
        if(whole_hours > 1){
          description += 's';
        }
      } else {
        description += rm.duration + ' minute'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        description += 'up to ' + rm.additional_devices + ' devices';
      } else {
        description += '1 device';
      }
      if(rm.speed_upload && rm.speed_download){
        description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },

    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData: async function(){
      // If no access code set, show required text
      if(this.registration_method.type=='accesscode' && !this.form.access_code){
        this.access_code_valid = false;
        return;
      }
      if(this.clicked){
        return;
      }
      this.clicked = true;


      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
        marketing_consent: false
      };
      if(this.registration_method.registration_method_id=='1'){
        emitted.rateplan_id = this.registration_method.id;
      } else if(this.registration_method.registration_method_id=='2'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if(this.registration_method.registration_method_id=='3'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
      } else if(this.registration_method.registration_method_id=='4'){
        emitted.access_code = this.form.access_code;
      }

      if(this.form.consent){
        const revinate_data = {
          tokens: [this.revinate.list_token],
          contacts: [
            { email: this.form.email_address, first_name: this.form.first_name, last_name: this.form.last_name, state: this.form.state_selected },
          ]
        };
        Axios.post(this.revinate.url,revinate_data).then(response => {
          this.$emit('emitRegistrationMethodData', emitted);
        }).catch( error => {
          this.$emit('error', 'Error registering with email address.');
        });
      } else {
        this.$emit('emitRegistrationMethodData', emitted);
      }
    },
  }
}
</script>
<style scoped>
.rm .btn { background: #384143; color: #ffffff; }

select {
    width: 100%;
    height: 50px;
    border-radius: 4px;
}
</style>
